module.exports = __webpack_public_path__ + "img/de.2c249243.png";